import BigNumber from 'bignumber.js';
import { isEmpty, find } from 'lodash';
import {
  FETCH_ALL_ORDER,
  FETCH_ALL_ORDER_FAILED,
  FETCH_ALL_ORDER_SUCCEED,
  FETCH_OPEN_ORDER,
  FETCH_OPEN_ORDER_FAILED,
  FETCH_OPEN_ORDER_SUCCEED,
  FETCH_ORDER_PAGINATE,
  FETCH_ORDER_PAGINATE_SUCCEED,
  FETCH_ORDER_PAGINATE_FAILED,
  WS_EVENT_ORDER_CREATED,
  WS_EVENT_ORDER_CANCELED,
  WS_EVENT_OPEN_ORDER,
  FETCH_OPEN_ORDERS_PAGINATE,
  FETCH_OPEN_ORDERS_PAGINATE_SUCCEED,
} from '../actions/order/action_types';
import utils from '../../common/utils';
import consts from '../../consts';

function transformOpenOrder(data = []) {
  window._.forEach(data, (item) => {
    item.key = item.id;
    item.pair = `${item.coin}/${item.currency}`.toUpperCase();
    item.total = window._.trimEnd(utils.trimRightZero(new BigNumber(item.price).times(item.quantity).toFixed(8)), '.');
    item.filled = `${new BigNumber(item.executed_quantity).div(new BigNumber(item.quantity).plus(item.executed_quantity)).times(100).toFixed(2)}%`;
    item.order_type = utils.parseOrderType(item.type);
    item.tradeType = utils.parseOrderTradeType(item.trade_type);
  });
}

export default (state = {
  orders: [],
  openOrders: [],
  ordersPaginate: [],
  totalCountOpenOrder: 0,
  isTableLoading: false,
  isTableOpenOrderLoading: false,
  height: 0,
}, action) => {
  switch (action.type) {
    case FETCH_ALL_ORDER:
      return {
        ...state,
        isTableLoading: true,
      };
    case FETCH_ALL_ORDER_SUCCEED:
      return {
        ...state,
        orders: window._.map(action.params.data, (item) => {
          item.key = item.id;
          item.pair = `${item.coin}/${item.currency}`;
          return item;
        }),
        isTableLoading: false,
      };
    case FETCH_ALL_ORDER_FAILED:
      return {
        ...state,
        isTableLoading: false,
      };
    case FETCH_OPEN_ORDER:
      return {
        ...state,
        isTableOpenOrderLoading: true,
        height: 0,
      };
    case FETCH_OPEN_ORDER_FAILED:
      return {
        ...state,
        isTableOpenOrderLoading: false,
      };
    case FETCH_OPEN_ORDER_SUCCEED:
      transformOpenOrder(action.data);

      return {
        ...state,
        openOrders: action.data,
        totalCountOpenOrder: action.total_count,
        isTableOpenOrderLoading: false,
        height: 0,
      };
    case FETCH_ORDER_PAGINATE:
      return {
        ...state,
        isTableLoading: true,
      };
    case FETCH_OPEN_ORDERS_PAGINATE_SUCCEED:
      transformOpenOrder(action.params.data.data);

      return {
        ...state,
        openOrders: action.params.data.data,
        totalCountOpenOrder: action.params.data.total_count,
        isTableOpenOrderLoading: false,
      };
    case FETCH_ORDER_PAGINATE_SUCCEED:
      return {
        ...state,
        totalCountOrderPaginate: action.params.data.total_count,
        ordersPaginate: window._.map(action.params.data.data, (item) => {
          item.key = item.id;
          return item;
        }),
        isTableLoading: false,
      };
    case WS_EVENT_ORDER_CREATED:
      let checkId = {};
      if (state.openOrders.length > consts.DEFAULT_PAGE_SIZE_OPEN_ORDER) {
        state.openOrders.pop();
      }
      checkId = find(state.openOrders, (o) => o.id === action.data.id);
      const item = action.data;
      item.pair = `${item.coin}/${item.currency}`.toUpperCase();
      item.total = window._.trimEnd(utils.trimRightZero(new BigNumber(item.price).times(item.quantity).toFixed(8)), '.');
      item.filled = `${new BigNumber(item.executed_quantity).div(new BigNumber(item.quantity).plus(item.executed_quantity)).times(100).toFixed(2)}%`;
      item.order_type = utils.parseOrderType(item.type);
      item.tradeType = utils.parseOrderTradeType(item.trade_type);
      return {
        ...state,
        openOrders: isEmpty(checkId) ? [item, ...state.openOrders] : state.openOrders,
      };
    case WS_EVENT_OPEN_ORDER:
      transformOpenOrder(action.data);
      if (action.options != null) {
        utils.showNotification(window.$t('message.matching_order_title'), window.$t('message.matching_order', action.options));
      }

      return {
        ...state,
        openOrders: action.data,
      };
    case FETCH_ORDER_PAGINATE_FAILED:
      return {
        ...state,
        isTableLoading: false,
      };
    default:
      return {
        ...state,
      };
  }
};
